// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styleHelpers-borderInput_cls1__1AHcF","cls2":"styleHelpers-borderInput_cls2__1s5B6 styleHelpers-borderInput_cls1__1AHcF"};